import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { SET_OAUTH_REDIRECT_ALLOWLIST } from "./gql";

const useSetOauthRedirectAllowlist = createDefaultMutationHook(SET_OAUTH_REDIRECT_ALLOWLIST);

export default useSetOauthRedirectAllowlist;
